module.exports = __webpack_public_path__ + "static/media/community-concessions-banner.e0a75264.jpg";